import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-ee8d984e")
const _hoisted_1 = { class: "authentication-container" }
const _hoisted_2 = { class: "title lager-font" }
const _hoisted_3 = {
  key: 0,
  class: "line medi-font"
}
const _hoisted_4 = {
  key: 1,
  class: "line medi-font"
}
const _hoisted_5 = {
  key: 2,
  class: "line medi-font"
}
const _hoisted_6 = {
  key: 3,
  class: "line medi-font"
}
const _hoisted_7 = { class: "swip-box" }
const _hoisted_8 = {
  key: 0,
  class: "prev-next"
}
const _hoisted_9 = { class: "prve" }
const _hoisted_10 = {
  key: 0,
  src: "https://qnui.xfarmer.com/xfarmer-ui/trace/组 113@2x.png"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "next" }
const _hoisted_13 = {
  key: 0,
  src: "https://qnui.xfarmer.com/xfarmer-ui/trace/%E7%BB%84%20817%402x.png"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "img-wrap" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_list, {
      class: "authentication-list",
      offset: 10,
      onLoad: _ctx.onBottom
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "authentication-item",
            key: item.id
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", null, _toDisplayString(item.name), 1)
            ]),
            (item.institution)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("span", null, _toDisplayString(item.type == 1 ? "认证机构：" : "检测机构："), 1),
                  _createElementVNode("span", null, _toDisplayString(item.institution), 1)
                ]))
              : _createCommentVNode("", true),
            (item.code)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("span", null, _toDisplayString(item.type == 1 ? "证书编号：" : "报告编号："), 1),
                  _createElementVNode("span", null, _toDisplayString(item.code), 1)
                ]))
              : _createCommentVNode("", true),
            (item.intro)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("span", null, _toDisplayString(item.type == 1 ? "认证介绍：" : "检测介绍："), 1),
                  _createElementVNode("span", null, _toDisplayString(item.intro), 1)
                ]))
              : _createCommentVNode("", true),
            (item.time)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("span", null, _toDisplayString(item.type == 1 ? "发证日期：" : "检测日期："), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.replaceTime(item.time)), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              (item.newImgs.length>1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      (item.current == 0)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            onClick: ($event: any) => (_ctx.prev(index,item.id)),
                            src: "https://qnui.xfarmer.com/xfarmer-ui/trace/%E7%BB%84%20819%402x.png"
                          }, null, 8, _hoisted_11))
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      (item.current == item.newImgs.length - 1)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            onClick: ($event: any) => (_ctx.next(index,item.id)),
                            src: "https://qnui.xfarmer.com/xfarmer-ui/trace/%E7%BB%84%20818%402x.png"
                          }, null, 8, _hoisted_14))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_van_swipe, {
                class: "swipe-container",
                "show-indicators": false,
                touchable: false,
                ref: _ctx.getEl,
                loop: false
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.newImgs, (val, index) => {
                    return (_openBlock(), _createBlock(_component_van_swipe_item, { key: index }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_van_image, {
                            fit: "cover",
                            src: val.url,
                            class: "images",
                            onClick: ($event: any) => (_ctx.onPreviewImg(val, item.fileImgs)),
                            alt: ""
                          }, null, 8, ["src", "onClick"])
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 2
              }, 1536)
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["onLoad"])
  ]))
}